export default function() {
  // ищем все теги input привязанные к select для ввода строки поиска
  const autocompleteSelects = document.querySelectorAll('.autocomplete_search_input');

  // для всех имеющихся поисковых input'ов делаем обработку ввода
  autocompleteSelects.forEach(input => {
    // здесь будем хранить текущее значение input до начала поиска
    let currentSearchValue = '';

    // находим через родительский элемент select относящийса к текущему input
    const dataSelect = input.parentNode.querySelector('.autocomplete_select');
    let   data = [];

    // сохраняем имеющиеся в select варианты
    // в отдельной переменной
    for (const option of dataSelect) {
      const selectItem = {
        id: option.value,
        text: option.label,
      }

      data.push(selectItem);
    }

    // через js создаем родительский элемент wrapper для input
    // возможно лучше сделать это сразу в верстке
    const wrap = document.createElement('div');
    wrap.className = 'autocomplete_wrap';
    input.parentNode.insertBefore(wrap, input)
    wrap.appendChild(input)

    // в этом элементе wrap добавляем элемент содеражащий совпавшие при поиске элементы
    let list = document.createElement('div');
    list.className = 'autocomplete_list';
    wrap.appendChild(list);

    let listItems = [];
    let itemForFocus = -1;

    function setActive(active = true) {
      if (active) {
        wrap.classList.add('active');
      } else {
        wrap.classList.remove('active');
      }
    }

    function focusItem(index) {
      if (!listItems.length) {
        return false;
      }
      if (index > listItems.length - 1) {
        return focusItem(0);
      }
      if (index < 0) {
        return focusItem(listItems.length - 1);
      }

      itemForFocus = index;
      unfocusAllItems();
      listItems[itemForFocus].classList.add('focused');
    }

    function unfocusAllItems() {
      listItems.forEach(item => {
        item.classList.remove('focused');
      });
    }

    function selectItem(index) {
      if (!listItems[index]) {
        return false;
      }

      input.value = listItems[index].innerText;
      // при клике на поисковом input поле очищается, перед его очисткой сохраняем его значение
      // на случай если не будет выбрано значение из выпадающего виртуального списка с классом "autocomplete_list"
      currentSearchValue = input.value;

      dataSelect.value = listItems[index].getAttribute('data-select-value');
      setActive(false);
    }

    // при первоначальном клике по input для ввода строки поиска
    // сохраняем его значение в переменную для восстановления, если
    // не будет найдено совпадение или будет клик по другой области страницы и отмена поиска.
    input.addEventListener('click', e => {
      currentSearchValue = input.value;
      input.value = '';
    });

    // обрабатываем ввод строки для поиска
    input.addEventListener('input', () => {
      let value = input.value;
      if (!value) {
        setActive(false);
      }

      list.innerHTML = '';
      listItems = [];

      data.forEach((dataItem, index) => {
        // ищем с начала строки
        const searchResult = dataItem.text.toUpperCase().search(value.toUpperCase());

        if (searchResult === -1) {
          return false;
        }

        // если найдено совпадение добавляем найденое значение в выпадающий список
        const searchedItem = document.createElement('div');
        searchedItem.className = 'autocomplete_item';
        searchedItem.setAttribute('data-select-value', dataItem.id);
        searchedItem.innerText = dataItem.text;
        list.appendChild(searchedItem);
        listItems.push(searchedItem);

        // обрабатываем клик по элементу выпадающего списка
        searchedItem.addEventListener('click', () => {
          selectItem(listItems.indexOf(searchedItem));
        });
      });

      // если есть найденные совпадения, то показываем выпадающий список
      if (listItems.length > 0) {
        setActive(true);
      } else {
        setActive(false);
      }
    });

    // обрабатываем работу с выдающим списком через клавиатуру
    input.addEventListener('keydown', e => {
      let keyCode = e.keyCode;

      if (keyCode === 40) { // стрелка вниз
        e.preventDefault();
        itemForFocus++;
        focusItem(itemForFocus);
      } else if (keyCode === 38) { // стрелка вверх
        e.preventDefault();

        if (itemForFocus > 0) {
          itemForFocus--;
        }

        focusItem(itemForFocus);
      } else if (keyCode === 27) { // escape
        setActive(false);
      } else if (keyCode === 13) { // enter
        e.preventDefault();
        selectItem(itemForFocus);
      }
    });

    // если будет клик по области не относящейся к выпадающему списку, то
    // скрываем список и восстанавливаем его предыдущее значение (если оно не пустое)
    document.body.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) {
        setActive(false);

        if (currentSearchValue.length) {
          input.value = currentSearchValue;
        }
      }
    });
  });
}